import * as Sentry from '@sentry/gatsby'

import buildAddToCartObject from './buildAddToCartObject'
import dynamicYieldEvents from './dynamicYieldEvents'

type TrackAddToCartParams = Parameters<typeof buildAddToCartObject>[0]

/**
 * Sends the Dynamic Yield "Add To Cart" event without ever throwing.
 * Tracking is telemetry: a failure here must not stop the item from being
 * added to the cart, so errors are reported to Sentry and swallowed.
 */
export default function trackAddToCart(params: TrackAddToCartParams) {
  try {
    dynamicYieldEvents(buildAddToCartObject(params))
  } catch (error) {
    const err = error instanceof Error ? error : new Error(String(error))

    Sentry.captureException(err, {
      tags: { dy_tracking: 'true', ssr: 'false', step: 'add-to-cart' },
      extra: { message: err.message, stack: err.stack ?? 'No stack trace' },
    })
  }
}
